import axios from "axios";
import { baseUrl, config, requestID } from "../common/utils";

export const getProcedures = async (payload?: any) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_Procedures/getProcedures",
            data,
            config
        );
        console.log("procedures 00", response);
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const createProcedure = async (payload: any) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_Procedures/createProcedure",
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const updateProcedure = async ( payload: any) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + `Geacloud_Procedures/updateProcedure`,
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const deleteProcedure = async (id: string) => {
    const data = {
        requestID: requestID(),id
    };
    try {
        const response = await axios.post(
            baseUrl() + `Geacloud_Procedures/deleteProcedure`,
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const getProcedure = async (id: string) => {
    const data = {
        requestID: requestID(),
        geacloud_procedures_id: id
    };
    try {
        const response = await axios.post(
            baseUrl() + `Geacloud_Procedures/getProcedureById`,
            data,
            config
        );
        
        console.log({response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const searchProcedures = async (payload: any) => {
    const data = {
        requestID: requestID(),
        data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_Procedures/searchProcedures",
            data,
            config
        );
        console.log('search', response);
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const getProcedureSummary = async () => {
    const data = {
        requestID: requestID()
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_Procedures/summary",
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};
